import React, { useState } from 'react';
import { CopyIcon } from '@radix-ui/react-icons';
import { IconButton } from '@producer/ui-kit';

import { Tooltip } from '../../../components/tooltip/Tooltip';

import styles from './shareable-link.module.scss';
type ShareableLinkProps = {
  url?: string;
};

export const ShareableLink: React.FC<ShareableLinkProps> = ({ url }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async (e?: React.MouseEvent) => {
    e?.preventDefault();

    if (!url) {
      return;
    }

    setIsCopied(true);
    await navigator.clipboard.writeText(url);
  };

  return (
    <div className={styles['container']}>
      <div className={styles['link-wrapper']}>
        <a className={styles['link']} onClick={handleCopy}>
          {url}
        </a>

        <Tooltip text="Copied" disabled={!isCopied} position="bottom">
          <IconButton
            icon={<CopyIcon />}
            variant="transparent"
            onClick={handleCopy}
            onMouseLeave={(e) => {
              setIsCopied(false);
              e.currentTarget.blur();
            }}
          />
        </Tooltip>
      </div>
    </div>
  );
};
